import React from 'react';
import './FormFieldMessage.scss';

// Includes ability to display non error messages

export default function FormFieldMessage( { touched, message, isError } ) {
	return (
		<div className={`form-field-message-box ${isError && 'error'}`}>{touched && message}&nbsp;</div>
	)
};